import { useQuery } from "@tanstack/react-query";
import { api } from "@/APIRequests";

export function usePolicyMetadataQuery() {
  return useQuery({
    queryKey: ["policyMetadata"],
    queryFn: api.publicTyped.get_policy_metadata,
    staleTime: 10 * 60 * 1000, // 10 minutes - policies don't change often
    cacheTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
  });
}
